import React from 'react';

interface Props {
  style?: React.CSSProperties;
  fillColor?: string;
  className?: string;
}
function BottomChevron({ style, fillColor, className = '' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      style={style}
      viewBox="0 0 14 13"
      className={className}
      fill="none">
      <g clipPath="url(#clip0_193_1613)">
        <path
          d="M7.36113 10.78L7.93496 10.2472L12.81 5.72042L13.3863 5.18523L12.2361 4.11719L11.6623 4.65003L7.36113 8.64397L3.05996 4.65239L2.48613 4.11719L1.33594 5.18523L1.90977 5.71807L6.78477 10.2449L7.36113 10.78Z"
          fill={fillColor || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_193_1613">
          <rect
            width="13"
            height="12.0714"
            fill="white"
            transform="translate(0.861328 0.660156)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BottomChevron;
